import {matchPath}  from 'react-router';
import Translations from '../../../utils/Translations';

const CONTAINER_ID = "myvisitx-favorites-containers";
const CONTENT_ID   = "myvisitx-favorites-contents";

const TILES_PER_PAGE  = 20;
const AUTO_LOAD_PAGES = 4;

const t = (key, ...args) => Translations.get(`myvisitx_mediathek.${key}`, args);

const ROUTES = {
    MyVisitXMediathek:                ':language/:myvisitx/mediathek/',
    MyVisitXMediathekVideos:          'videos/',
    MyVisitXMediathekVideosFeed:      'feed/',
    MyVisitXMediathekVideosMessenger: 'messenger/',
    MyVisitXMediathekVideosPinned:    'pinned/',
    MyVisitXMediathekPhotos:          'photos/',
    MyVisitXMediathekPhotosFeed:      'feed/',
    MyVisitXMediathekPhotosMessenger: 'messenger/',
    MyVisitXMediathekPhotosPinned:    'pinned/',
    MyVisitXMediathekAudio:           'audio/',
};

const SECOND_NAVIGATION_ITEMS = {
    VIDEOS: 'videos',
    PHOTOS: 'photos',
    AUDIO:  'audio',
};

const newVar                 = {
    SHOP:      'shop',
    FEED:      'feed',
    MESSENGER: 'messenger',
    PINNED:    'pinned',
};
const THIRD_NAVIGATION_ITEMS = newVar;

const baseRoute = ROUTES.MyVisitXMediathek;

const isActivePath = (path, pathname) => Boolean(matchPath({path}, pathname));

const isActivePathVideosFeed      = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekVideos + ROUTES.MyVisitXMediathekVideosFeed + '*', pathname);
const isActivePathVideosMessenger = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekVideos + ROUTES.MyVisitXMediathekVideosMessenger + '*', pathname);
const isActivePathVideosPinned    = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekVideos + ROUTES.MyVisitXMediathekVideosPinned + '*', pathname);
const isActivePathVideosShop      = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekVideos + '*', pathname);
const isActivePathVideos          = (pathname) => isActivePathVideosFeed(pathname) || isActivePathVideosMessenger(pathname) || isActivePathVideosPinned(pathname) || isActivePathVideosShop(pathname);

const isActivePathPhotosFeed      = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekPhotos + ROUTES.MyVisitXMediathekPhotosFeed + '*', pathname);
const isActivePathPhotosMessenger = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekPhotos + ROUTES.MyVisitXMediathekPhotosMessenger + '*', pathname);
const isActivePathPhotosPinned    = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekPhotos + ROUTES.MyVisitXMediathekPhotosPinned + '*', pathname);
const isActivePathPhotosShop      = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekPhotos + '*', pathname);
const isActivePathPhotos          = (pathname) => isActivePathPhotosFeed(pathname) || isActivePathPhotosMessenger(pathname) || isActivePathPhotosPinned(pathname) || isActivePathPhotosShop(pathname);

const isActivePathAudio = (pathname) => isActivePath(baseRoute + ROUTES.MyVisitXMediathekAudio + '*', pathname);

const convertToV2 = (items) => items.map(items => items.asset);

export {
    ROUTES,
    baseRoute,
    t,
    isActivePath,
    // videos
    isActivePathVideos,
    isActivePathVideosFeed,
    isActivePathVideosMessenger,
    isActivePathVideosPinned,
    isActivePathVideosShop,
    // photos
    isActivePathPhotos,
    isActivePathPhotosFeed,
    isActivePathPhotosMessenger,
    isActivePathPhotosPinned,
    isActivePathPhotosShop,
    // audio
    isActivePathAudio,
    convertToV2,
    SECOND_NAVIGATION_ITEMS,
    THIRD_NAVIGATION_ITEMS,
    CONTAINER_ID,
    CONTENT_ID,
    TILES_PER_PAGE,
    AUTO_LOAD_PAGES
};
